import React, { useState, useEffect } from 'react';
import { func, oneOfType, number, string, array, object, bool } from 'prop-types';
import { map, uniq, size, filter, includes } from 'lodash';
import { FormSelect } from '../Select';
import { companyGroups } from '../../../utils/misc';

const CompanyGroupsSelect = ({
    sessionSalesChannel,
    onChange: callback,
    width,
    initialValue,
    defaultValue,
    multiple
}) => {
    const sessionStoreKinds = uniq(map(sessionSalesChannel, ({ kind }) => kind));
    const getOptions = map(size(sessionStoreKinds) ? filter(companyGroups, e => includes(sessionStoreKinds, e)) : companyGroups, label => ({ label, value: label }));
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        callback(value);
    }, [value]);

    return (
        <FormSelect
            style={{ width: `${width}` || '100%' }}
            label='Bandera'
            options={getOptions}
            defaultValue={defaultValue || null}
            value={value}
            onChange={({ value }) => {
                setValue(value);
            }}
            multiple={multiple}
        />
    );
};

CompanyGroupsSelect.propTypes = {
    sessionSalesChannel: array,
    onChange: func,
    width: oneOfType([number, string]),
    initialValue: object,
    multiple: bool
};

CompanyGroupsSelect.defaultProps = {
    onChange: () => {},
    sessionSalesChannel: []
};

export default CompanyGroupsSelect;
